import React from "react";
import "../../components/PdfCreation/quiz.scss";
import QuestionTitle from "../../components/Quiz/QuestionBox/QuestionTitle";
import { formatQuestion, TimeUtils } from "examsbook-react-sdk/common";
import useStyles from "examsbook-react-sdk/custom-hooks/useStyles";
import useUserLanguage from "examsbook-react-sdk/custom-hooks/useUserLanguage";
import QuestionOptionList from "../../components/Quiz/QuestionBox/QuestionOptionList";
import './Pdf.scss';
import ExplanationSection from "../../components/Quiz/QuestionBox/ExplanationSection";

const ReportTabularView = (props) => {
    const { questions, totalMarks, t } = props;
    const { language } = useUserLanguage();
    const classes = useStyles(styles)();

    function onRadioChange() {
        return;
    }

    function changeTimeFormat(spentTime) {
        return TimeUtils.changeTimeFormat(spentTime);
    }

    return (
        <div id="quizTable">
            {!questions || questions.length === 0 ? (
                "You currently have no report"
            ) : (
                <>
                <table className="table">
                    <thead>
                    <tr className="table-column">
                        <th></th>
                        <th>{t("QUESTION")}</th>
                        <th></th>
                    </tr>
                    </thead>
                </table>
                    {
                        <div>
                        {questions.map((ques, index) => {
                            const {
                                type,
                                explanation,
                                localesExplanation,
                                localesTitle,
                                title,
                                mark,
                                penalty,
                                givenAnswer,
                                timeSpent,
                                direction,
                                options,
                                markObtain,
                                className,
                                localesDirection,
                            } = formatQuestion(ques, true, language);
                            return (
                                <div className="td" key={index}>
                                    <QuestionTitle
                                        isPdf={true}
                                        mark={markObtain ? markObtain : "0"}
                                        questionMark={mark}
                                        penalty={penalty}
                                        classNameInView={
                                            className ? className : classes.marksBadges
                                        }
                                        timeSpent={
                                            timeSpent ? changeTimeFormat(timeSpent) : "00:00"
                                        }
                                        viewMode={true}
                                        direction={direction}
                                        title={title}
                                        total={ques.length}
                                        number={index + 1}
                                        localesTitle={localesTitle}
                                        localesDirection={localesDirection}
                                    />

                                    <QuestionOptionList
                                        options={options}
                                        type={type}
                                        showAnswer={true}
                                        viewMode={true}
                                        givenAnswer={givenAnswer}
                                        mode={true}
                                        onRadioChange={onRadioChange}
                                    />
                                    <ExplanationSection explanation={explanation} localesExplanation={localesExplanation} viewMode={true} mode={"view"}
                                                    showAnswer={true}/>
                                </div>
                            );
                        })}
                        <div className={classes.tableFooter}>
                            <span>Total Marks</span>
                            <span>{totalMarks ? totalMarks : 0}</span>
                        </div>
                        </div>
                    }
                </>
            )}
        </div>
    );
};

const styles = (theme) => ({

    marksBadges: {
        backgroundColor: "#ffc65820",
        color: "#ffc658",
        border: "1px solid #ffc658",
        borderRadius: 2,
        padding: "2px 6px",
        fontSize: 13,
        textAlign: "center",
        whiteSpace: "nowrap",
        marginRight: 0,
        display: "flex",
    },
    tableFooter: {
        color: '#009879',
        fontWeight: 'bold',
        fontSize: '20px',
        textAlign: 'left'
    }
});

export default ReportTabularView;
